// Generated by purs version 0.15.15
import * as Control_Alternative from "../Control.Alternative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Semigroupoid from "../Control.Semigroupoid/index.js";
import * as Data_Bounded_Generic from "../Data.Bounded.Generic/index.js";
import * as Data_Deprecated from "../Data.Deprecated/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Enum_Generic from "../Data.Enum.Generic/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid_Extra from "../Data.Monoid.Extra/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord_Generic from "../Data.Ord.Generic/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Data_Unfoldable1 from "../Data.Unfoldable1/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Prelude from "../Prelude/index.js";
import * as Restaumatic_UnwrapOperators from "../Restaumatic.UnwrapOperators/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var compose2 = function (dictSemigroupoid) {
    var compose1 = Control_Semigroupoid.compose(dictSemigroupoid);
    return function (f) {
        return function (g) {
            return function ($4) {
                return (function (v) {
                    return compose1(f)(v);
                })(g($4));
            };
        };
    };
};
export {
    compose2
};
export {
    alt,
    empty,
    guard
} from "../Control.Alternative/index.js";
export {
    lift2
} from "../Control.Apply/index.js";
export {
    genericBottom,
    genericTop
} from "../Data.Bounded.Generic/index.js";
export {
    deprecated
} from "../Data.Deprecated/index.js";
export {
    Left,
    Right,
    choose,
    either,
    fromLeft,
    fromRight,
    hush,
    isLeft,
    isRight,
    note,
    note$prime
} from "../Data.Either/index.js";
export {
    genericCardinality,
    genericFromEnum,
    genericPred,
    genericSucc,
    genericToEnum
} from "../Data.Enum.Generic/index.js";
export {
    genericEq
} from "../Data.Eq.Generic/index.js";
export {
    findMap,
    foldM,
    indexl,
    indexr,
    length,
    lookup,
    null,
    oneOfMap,
    product,
    surround,
    surroundMap
} from "../Data.Foldable/index.js";
export {
    applyFlipped
} from "../Data.Function/index.js";
export {
    Just,
    Nothing,
    fromJust,
    fromMaybe,
    fromMaybe$prime,
    isJust,
    isNothing,
    maybe,
    maybe$prime,
    optional
} from "../Data.Maybe/index.js";
export {
    munless,
    mwhen,
    mwith
} from "../Data.Monoid.Extra/index.js";
export {
    unwrap,
    wrap
} from "../Data.Newtype/index.js";
export {
    abs,
    add,
    negate,
    scale,
    sub,
    sum,
    zero
} from "../Data.Numeric/index.js";
export {
    genericCompare
} from "../Data.Ord.Generic/index.js";
export {
    getField
} from "../Data.Record/index.js";
export {
    genericShow
} from "../Data.Show.Generic/index.js";
export {
    all,
    and,
    any,
    elem,
    find,
    fold,
    foldMap,
    foldMapDefaultL,
    foldMapDefaultR,
    foldl,
    foldlDefault,
    foldr,
    foldrDefault,
    for,
    for_,
    intercalate,
    mapAccumL,
    mapAccumR,
    maximum,
    maximumBy,
    minimum,
    minimumBy,
    notElem,
    oneOf,
    or,
    scanl,
    scanr,
    sequence,
    sequenceDefault,
    sequence_,
    traverse,
    traverseDefault,
    traverse_
} from "../Data.Traversable/index.js";
export {
    Tuple,
    curry,
    fst,
    snd,
    swap,
    uncurry
} from "../Data.Tuple/index.js";
export {
    T2,
    fromTuple,
    proj1,
    proj2,
    toTuple
} from "../Data.Tuple.T2/index.js";
export {
    singleton
} from "../Data.Unfoldable1/index.js";
export {
    liftEffect
} from "../Effect.Class/index.js";
export {
    EQ,
    GT,
    LT,
    absurd,
    ap,
    append,
    apply,
    between,
    bind,
    bottom,
    clamp,
    compare,
    comparing,
    compose,
    conj,
    const,
    degree,
    discard,
    disj,
    div,
    eq,
    flap,
    flip,
    gcd,
    identity,
    ifM,
    join,
    lcm,
    liftA1,
    liftM1,
    map,
    max,
    mempty,
    min,
    mod,
    mul,
    not,
    notEq,
    one,
    otherwise,
    pure,
    recip,
    show,
    top,
    unit,
    unless,
    unlessM,
    void,
    when,
    whenM
} from "../Prelude/index.js";
export {
    applyUnwrap,
    applyUnwrapFlipped,
    applyUnwrapUnwrapped,
    applyUnwrapUnwrappedFlipped,
    applyUnwrapped,
    applyUnwrappedFlipped,
    composeFlippedUnwrapArg,
    composeFlippedUnwrapArgFun,
    composeFlippedUnwrapArgFunRes,
    composeFlippedUnwrapFun,
    composeFlippedUnwrapFunRes,
    composeFlippedUnwrapRes,
    composeUnwrapArg,
    composeUnwrapArgFun,
    composeUnwrapArgFunRes,
    composeUnwrapFun,
    composeUnwrapFunRes,
    composeUnwrapRes,
    mapUnwrap,
    mapUnwrapFlipped
} from "../Restaumatic.UnwrapOperators/index.js";
export {
    Proxy
} from "../Type.Proxy/index.js";
